"use strict";
var TypeMetadata = (function () {
    function TypeMetadata(target, propertyName, reflectedType, typeFunction) {
        this.target = target;
        this.propertyName = propertyName;
        this.reflectedType = reflectedType;
        this.typeFunction = typeFunction;
    }
    return TypeMetadata;
}());
exports.TypeMetadata = TypeMetadata;

//# sourceMappingURL=TypeMetadata.js.map



//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/metadata/TypeMetadata.js
// module id = 1455
// module chunks = 3